import { ReactComponent as add } from './add.svg';
import { ReactComponent as menu } from './menu.svg';
import { ReactComponent as close } from './close.svg';

export default {
  add,
  menu,
  close,
};
